var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSend16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7283 7.55368L2.74139 2.05281C2.65528 2.00969 2.55856 1.99241 2.46286 2.00306C2.36717 2.01371 2.27659 2.05182 2.20204 2.11282C2.13083 2.17258 2.07769 2.25104 2.04857 2.33938C2.01946 2.42772 2.01553 2.52245 2.03723 2.6129L3.51547 7.99875L2.01726 13.3696C1.99689 13.4451 1.99452 13.5244 2.01032 13.601C2.02612 13.6777 2.05965 13.7495 2.10823 13.8108C2.1568 13.8721 2.21906 13.9211 2.29 13.9539C2.36093 13.9867 2.43857 14.0024 2.51666 13.9997C2.59484 13.9992 2.67181 13.9804 2.74139 13.9447L13.7283 8.44382C13.8101 8.40186 13.8788 8.3381 13.9267 8.25957C13.9746 8.18104 14 8.09079 14 7.99875C14 7.90672 13.9746 7.81646 13.9267 7.73794C13.8788 7.65941 13.8101 7.59565 13.7283 7.55368ZM3.29074 12.5545L4.39442 8.49883H9.00893V7.49868H4.39442L3.29074 3.44303L12.3849 7.99875L3.29074 12.5545Z",
    fill: "#6D747D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend16);
export default __webpack_public_path__ + "static/media/Send16.8c25ddebcc7a8164b262614e9a0423ac.svg";
export { ForwardRef as ReactComponent };